import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { GitMerge } from 'lucide-react';

export default function DealsPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const { data, error } = await supabase
      .from('deals')
      .select('*, leads(name), companies(name)')
      .order('created_at', { ascending: false });
    
    if (error) console.error('Erreur:', error);
    else setData(data);
    setLoading(false);
  }

  const totalAmount = data.reduce((sum, deal) => sum + (deal.amount || 0), 0);

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-cyan-400 flex items-center gap-2">
          <GitMerge size={24} />
          Deals ({data.length})
        </h2>
        <div className="bg-gray-900 px-4 py-2 rounded-lg border border-gray-800">
          <span className="text-gray-400">Total: </span>
          <span className="text-green-400 font-bold">{totalAmount.toLocaleString()} €</span>
        </div>
      </div>
      
      {loading ? (
        <p className="text-gray-400">Chargement...</p>
      ) : (
        <div className="grid grid-cols-1 gap-4">
          {data.map(deal => (
            <div key={deal.id} className="bg-gray-900 rounded-xl border border-gray-800 p-5 hover:border-cyan-500/50 transition">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-white font-medium text-lg flex items-center gap-2">
                    {deal.leads?.name || 'Lead inconnu'}
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      deal.stage === 'gagné' ? 'bg-green-500/20 text-green-400' :
                      deal.stage === 'négociation' ? 'bg-yellow-500/20 text-yellow-400' :
                      'bg-blue-500/20 text-blue-400'
                    }`}>
                      {deal.stage}
                    </span>
                  </h3>
                  <p className="text-gray-400 text-sm mt-1">
                    Entreprise: {deal.companies?.name || 'Non spécifiée'}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-2xl font-bold text-green-400">{deal.amount?.toLocaleString()} €</p>
                  <p className="text-xs text-gray-500 mt-1">
                    {new Date(deal.created_at).toLocaleDateString()}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
